import React from "react";
import About from "../side_content";
import "./aboutUs.css";
import about from "./images/side-image.png";
import side_dots from "./images/side_dots.png";
import top_dots from "./images/top_dots.png";

import Heading from "../../heading/heading";

function AboutUs() {
  return (
    <div className="about-section">
      <Heading title="Who We Are" />
      <About
        side_image={about}
        side={side_dots}
        top={top_dots}
        title="Fidel Foundation"
        para="A non-governmental organization aiming 
        at lifting up the living standards of the children 
        and the youths with a positive and healthy mind."
      />
    </div>
  );
}

export default AboutUs;
